import apiClient from "./apiClient";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { AuthUserResponse } from "../models/ResponseModels/AuthUserResponse";
import { CreateCleanerRequest } from "../models/RequestModels/CreateCleanerRequest";
import { UpdateCleanerRequest } from "../models/RequestModels/UpdateCleanerRequest";

export const getCleanersRequest = async (): Promise<
  ApiCollectionResponse<AuthUserResponse>
> => {
  const response =
    await apiClient.get<ApiCollectionResponse<AuthUserResponse>>("/cleaners");

  return response.data;
};

export const createCleanerRequest = async (
  body: CreateCleanerRequest,
): Promise<ApiSingleResponse<AuthUserResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<AuthUserResponse>>(
    "/cleaners",
    body,
  );

  return response.data;
};

export const updateCleanerRequest = async (
  id: number,
  body: UpdateCleanerRequest,
): Promise<ApiSingleResponse<AuthUserResponse>> => {
  const response = await apiClient.patch<ApiSingleResponse<AuthUserResponse>>(
    `/cleaners/${id}`,
    body,
  );

  return response.data;
};

export const deleteCleanerRequest = async (id: number): Promise<number> => {
  await apiClient.delete(`/cleaners/${id}`);

  return id;
};
